import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const ignoredRequests: string[] = [];

  if (req.url && ignoredRequests.some(ignoreReq => req.url.includes(ignoreReq))) {
    return next(req);
  } else {
    Promise.resolve().then(() => loaderService.show());

    return next(req).pipe(
      finalize(() => Promise.resolve().then(() => loaderService.hide()))
    );
  }
};